import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import searchicon from "../../assets/images/ic_search.svg";
import ic_search_dark from "../../assets/images/ic_search_dark.svg";
import shareIcon from "../../assets/images/ic_export1.svg";
import BookIcon from "../../assets/images/ic_excel.svg";
import Modal from "react-bootstrap/Modal";
import Axe from "../../assets/images/sidebar/icons/axeMark.svg";
// import DelectAc from '../../assets/images/DelectAc.svg'
import DelectAc from "../../assets/images/DelectAcBlc.svg";
// import Editac from '../../assets/images/Editac.svg'
import Editac from "../../assets/images/bx_edit.svg";
import {
  PostCallWithErrorResponse,
  simpleGetCallWithToken,
  DeleteCallWithErrorResponseWithToken,
  simpleGetCallWithErrorResponse,
} from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import Loader from "../Loader";
import NoData from "../../sharedComponent/NoData";
import { notifyError, notifySuccess } from "../../toaster/notify";
import Pagination from "../../sharedComponent/Pagination";
import { getDateddmmyyyy } from "../../common";
import FileSaver from "file-saver";
import ExcelLoader from "../../sharedComponent/ExcelLoader";
import { useParams, useSearchParams } from "react-router-dom";
import { ToastMsg } from "../TostMsg";

const ViewList = () => {
  const { sidebar, setprojectIdTast, Dark, setDark, userData, permissions } =
    useContext(AppContext);
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientId");
  const [loading, setLoading] = useState(false);
  const [filterBy, setFilterBy] = useState("Active");
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);
  const [clientOptions, setClientOptions] = useState([]);
  const [departmentOptions, setdepartmentOptions] = useState([]);
  const [projectUpdateLoading, setProjectUpdateLoading] = useState(false);
  const [adminsList, setAdminsList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [projectData, setProjectData] = useState([]);
  console.log("projectData", projectData);
  const [gitUrlVal, setGitUrlVal] = useState("");

  const [gitUrls, setGitUrls] = useState([
    {
      RepositoryId: 0,
      ProjectId: 0,
      URL: "",
    },
  ]);

  const [deleteProjectName, setDeleteProjectName] = useState("");

  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUsersPerPage] = useState(25);

  const startIndex = currentPage * usersPerPage;
  const endIndex = startIndex + parseInt(usersPerPage);

  const pageChangeHandler = ({ selected }) => {
    setCurrentPage(selected);
  };

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);
  const [useDeleteTaskList, setDeleteTaskList] = useState("");
  const [excelLoading, setExcelLoading] = useState(false);

  const searchedDataPageCounts =
    projectData &&
    projectData.length &&
    projectData.filter((item) =>
      item.ProjectName?.toLowerCase().includes(searchValue)
    );

  const [projStateData, setProjStateData] = useState({
    ProjectName: "",
    Description: "",
    ProjAdmin: 0,
    StartDate: "",
    EndDate: "",
    IsInternal: false,
    IsExternal: false,
    EstimatedTime: "",
    Status: 0,
    DepartmentId: "",
    ProjectAwardedDate: "",
    ContractedModel: false,
    Rate: 0,
  });
  console.log(projStateData);

  const [notValidUrl, setNotValidUrl] = useState("");

  const clearForm = () => {
    setProjStateData({
      ProjectName: "",
      Description: "",
      ProjAdmin: 0,
      StartDate: "",
      EndDate: "",
      IsInternal: false,
      IsExternal: false,

      EstimatedTime: "",
      Status: 0,
      DepartmentId: "",
      ProjectAwardedDate: "",
      ContractedModel: false,
      Rate: 0,
    });
  };

  let projectAwardedDate =
    projStateData &&
    projStateData?.ProjectAwardedDate?.split("T")[0].replaceAll("/", "-");
  let StartDate =
    projStateData &&
    projStateData.StartDate?.split("T")[0].replaceAll("/", "-");
  let EndDate =
    projStateData && projStateData.EndDate?.split("T")[0].replaceAll("/", "-");

  const changeData = (e) => {
    const { name, value } = e.target;
    // setProjStateData({
    //   ...projStateData,
    //   [name]: value,
    // });

    setProjStateData((prevState) => {
      const updatedState = { ...prevState, [name]: value };

      // Calculate Estimated Hours when StartDate and EndDate are available
      if (name === "StartDate" || name === "EndDate") {
        if (updatedState.StartDate && updatedState.EndDate) {
          const start = new Date(
            updatedState.StartDate?.split("T"[0]?.replace("/", "-"))
          );
          const end = new Date(updatedState.EndDate);

          // Check if EndDate is greater than or equal to StartDate
          if (start <= end) {
            const hoursDifference = Math.abs(end - start) / (1000 * 60 * 60); // Convert milliseconds to hours
            updatedState.EstimatedTime = `${Math.round(hoursDifference)}`; // Auto-fill Estimated Hours
          } else {
            updatedState.EndDate = "";
            setClientErr((prev) => ({
              ...prev,

              EndDateErr:
                "End date must be greater than or equal to start date.",
            }));
          }
        }
      }

      return updatedState;
    });
    setClientErr({
      ...clientErr,
      [`${name}Err`]: value ? "" : clientErr[`${name}Err`],
    });
  };

  const initialErr = {
    ProjectNameErr: "",
    DescriptionErr: "",
    ProjAdminErr: "",
    StartDateErr: "",
    EndDateErr: "",
    IsInternalErr: "",
    IsExternalErr: "",

    EstimatedTimeErr: "",
    Status: 0,
    DepartmentIdErr: "",
    ProjectAwardedDateErr: "",
    ContractedModelErr: false,
    RateErr: "",
    ClientIdErr: "",
  };
  const [clientErr, setClientErr] = useState(initialErr);

  const [createProject] = useSearchParams();

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setClientErr(initialErr);
    setShow(false);
    setGitUrls([
      {
        RepositoryId: 0,
        ProjectId: 0,
        URL: "",
      },
    ]);
    setProjStateData({
      ProjectName: "",
      Description: "",
      ProjAdmin: 0,
      StartDate: "",
      EndDate: "",
      IsInternal: null,
      IsExternal: false,

      EstimatedTime: "",
      Status: 0,
      DepartmentId: "",
      ProjectAwardedDate: "",
      ContractedModel: false,
      Rate: 0,
      ClientId: null,
    });
  };

  const [urlValidation, setUrlValidation] = useState(false);

  const fetchProjectList = () => {
    setLoading(true);
    const apiUrl = clientId
      ? `${ApiConfig.GET_PROJECT_LIST_BY_CLIENT}${clientId}`
      : ApiConfig.GET_PROJECT_LIST;

    simpleGetCallWithToken(apiUrl)
      .then((res) => {
        console.log("res", res);
        if (res.Success === true) {
          setLoading(false);
          setProjectData(res?.Data);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // const projectDetailsValidaion = () => {
  //   console.log(projStateData);
  //   let isValid = true;

  //   let projectNameErr = "";
  //   let cliendNameErr = "";
  //   let deptErr = "";
  //   let projectAdminEr = "";
  //   let projectTypeErr = "";
  //   let projectContErr = "";
  //   let projectAwardedDateErr = "";
  //   let projectStartErr = "";
  //   let projectEndErr = "";
  //   let estimetedErr = "";

  //   if (!projStateData.ProjectName) {
  //     projectNameErr = "Please Enter Project Name";

  //     isValid = false;
  //   } else {
  //     projectNameErr = "";
  //   }

  //   if (!projStateData.ClientId) {
  //     cliendNameErr = "Please Select Client Name";

  //     isValid = false;
  //   } else {
  //     cliendNameErr = "";
  //   }

  //   if (!projStateData.DepartmentId) {
  //     deptErr = "Please Select Department";

  //     isValid = false;
  //   } else {
  //     deptErr = "";
  //   }
  //   if (!projStateData.ProjAdmin) {
  //     projectAdminEr = "Please Seletc Project Admin";

  //     isValid = false;
  //   } else {
  //     projectAdminEr = "";
  //   }

  //   // if (!projStateData.IsInternal || !projStateData.IsExternal) {
  //   //   projectTypeErr = "Pleas Select Project Type";

  //   //   isValid = false;
  //   // } else {
  //   //   projectTypeErr = "";
  //   // }

  //   if (!projStateData.ProjectAwardedDate) {
  //     projectAwardedDateErr = "Please Select Project Awarded Data";

  //     isValid = false;
  //   } else {
  //     projectAwardedDate = "";
  //   }

  //   if (!projStateData.StartDate) {
  //     projectStartErr = "Please Select Project Start Date";

  //     isValid = false;
  //   } else {
  //     projectStartErr = "";
  //   }

  //   if (!projStateData.EndDate) {
  //     projectEndErr = "Please Seletc Project End Date";

  //     isValid = false;
  //   } else {
  //     projectEndErr = "";
  //   }

  //   if (!projStateData.EstimatedTime) {
  //     estimetedErr = "Please Enter Project Estimeted Time";

  //     isValid = false;
  //   } else {
  //     estimetedErr = "";
  //   }

  //   setClientErr({
  //     ProjectNameErr: projectNameErr,
  //     ProjAdminErr: projectAdminEr,
  //     StartDateErr: projectStartErr,
  //     EndDateErr: projectEndErr,
  //     IsInternalErr: projectTypeErr,
  //     IsExternalErr: projectTypeErr,
  //     EstimatedTimeErr: estimetedErr,
  //     Status: 0,
  //     DepartmentIdErr: deptErr,
  //     ProjectAwardedDateErr: projectAwardedDateErr,
  //     ContractedModelErr: false,
  //     RateErr: "",
  //     ClientIdErr: cliendNameErr,
  //   });

  //   return isValid;
  // };

  useEffect(() => {
    fetchProjectList();
  }, []);
  const [projBool, setProjBool] = useState(false);
  useEffect(() => {
    setProjBool(projBool);
  }, [projBool]);
  // GET PROJECT EDITED DATA BY PROJECT ID API
  const getProjectDataById = (projectId) => {
    setprojectIdTast(projectId);
    console.log("projectId,", projectId);
    let payLoad = {
      ProjectId: projectId,
    };

    simpleGetCallWithErrorResponse(
      ApiConfig.GET_PROJECT_REPOS + projectId
    ).then((res) => {
      if (res?.json?.Success) {
        setGitUrls(res?.json?.Data);
      }
    });

    PostCallWithErrorResponse(
      ApiConfig.POST_DATA_WITH_PROJECT_ID,
      JSON.stringify(payLoad)
    )
      .then((res) => {
        console.log("res,", res);
        if (res.json.Success === true) {
          let responce = res.json.Data;

          setProjStateData({
            projectId: responce?.Id,
            ClientId: responce?.CustomerId,
            ProjectName: responce?.ProjectName,
            Description: responce?.Description,
            ProjAdmin: responce?.ProjAdmin,
            StartDate: responce?.StartDate,
            EndDate: responce?.EndDate,
            IsInternal: responce?.IsInternal,
            IsExternal: responce?.IsExternal,
            EstimatedTime: responce?.EstimatedTime,
            Status: responce?.Status,
            DepartmentId: responce?.DepartmentId,
            ProjectAwardedDate: responce?.ProjectAwardedDate,
            ContractedModel: responce?.ContractedModel,
            Rate: responce?.Rate,
          });
          setProjBool(responce?.IsInternal);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const urlTest = (url) => {
    const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;

    return urlPattern.test(url);
  };

  const testUrl = () => {
    let valid = true;

    const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;

    gitUrls.forEach((i) => {
      if (!urlPattern.test(i.URL)) {
        valid = false;
      }
    });

    return valid;
  };

  // UPDATE PROJECT API
  const updateProject = () => {
    // let isValid = projectDetailsValidaion();

    // if (!isValid) return;

    // if (!testUrl()) {

    //   setUrlValidation(true)

    //   return
    // }
    setProjectUpdateLoading(true);
    projStateData.projectRepositories = gitUrls;

    PostCallWithErrorResponse(
      ApiConfig.UPDATE_PROJECT,
      JSON.stringify(projStateData)
    )
      .then((res) => {
        if (res.json.Success === true) {
          notifySuccess("Project updated successfully");
          fetchProjectList();
          setEdit(false);
          clearForm();
          setGitUrls([
            {
              RepositoryId: 0,
              ProjectId: 0,
              URL: "",
            },
          ]);
          setUrlValidation(false);
        } else {
          console.log("error res,", res);
        }
      })
      .catch((err) => {
        console.log("error response,", err);
      })
      .catch(() => {
        setProjectUpdateLoading(false);
      });
  };

  const addGitUrl = () => {
    // const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;

    // if (!urlPattern.test(gitUrlVal)) {

    //   setNotValidUrl('please Enter valid Url')

    //   return

    // }
    let temp = [
      ...gitUrls,
      {
        RepositoryId: 0,
        ProjectId: 0,
        URL: gitUrlVal,
      },
    ];

    setGitUrls(temp);

    setGitUrlVal("");

    setNotValidUrl("");
  };

  // DELETE PROJECT API
  const deleteProject = (projectId) => {
    let payLoad = {
      ProjectId: projectId,
    };

    DeleteCallWithErrorResponseWithToken(
      ApiConfig.DELETE_PROJECT,
      JSON.stringify(payLoad)
    )
      .then((res) => {
        if (res.json.Success === true) {
          ToastMsg("success", res?.json?.Message);
          fetchProjectList();
        } else {
          console.log("error", res);
        }
      })
      .catch((err) => {
        console.log("error response", err);
      });
  };

  const displayAdminTask = (
    <table>
      <thead>
        <tr className="firstTabelRow">
          <th>Sr.no</th>
          <th>Project Name</th>
          <th>Project Admin</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Estimate Hours</th>
          <th>Project Type</th> {/* Changed Header from "Is Internal" */}
          <th>Status</th>
          {/* Action column is commented out in your original code */}
        </tr>
      </thead>
      <tbody>
        {projectData.map((admin, index) => {
          return (
            <tr className="table-row-custom" key={admin.ProjectId}>
              {" "}
              {/* Use a unique key like ProjectId */}
              <td>{startIndex + index + 1}</td>
              <td>{admin.ProjectName || "No Data"}</td>
              <td>{admin.AdminName || "No Data"}</td>
              <td>
                {admin.StartDate ? getDateddmmyyyy(admin.StartDate) : "No Data"}
              </td>
              <td>
                {admin.EndDate ? getDateddmmyyyy(admin.EndDate) : "No Data"}
              </td>
              <td>{admin.BudgetHours || "No Data"}</td>
              <td>
                {/* Correctly check the boolean value of IsInternal */}
                {admin.IsInternal === true ? "Internal" : "External"}
              </td>
              <td
                className={`${admin.Status === "Active"
                  ? "status-green"
                  : admin.Status === "Close"
                    ? "status-green-dark"
                    : admin.Status === "New"
                      ? "status-label-grey"
                      : "status-red"
                  }`}
              >
                {admin.Status || "No Data"}
              </td>
              {/* Action column logic remains commented out as per your code */}
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  const displaySearchAdminTask = (
    <table>
      <thead>
        <tr className="firstTabelRow">
          <th>Sr.no</th>
          <th>Project Name</th>
          <th>Project Admin</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Estimate Hours</th>
          <th>Project Type</th> {/* Changed Header from "Is Internal" */}
          <th>Status</th>
          {/* Action column is commented out in your original code */}
        </tr>
      </thead>
      <tbody>
        {projectData.map((admin, index) => {
          return (
            <tr className="table-row-custom" key={admin.ProjectId}>
              {" "}
              {/* Use a unique key like ProjectId */}
              <td>{startIndex + index + 1}</td>
              <td>{admin.ProjectName || "No Data"}</td>
              <td>{admin.AdminName || "No Data"}</td>
              <td>
                {admin.StartDate ? getDateddmmyyyy(admin.StartDate) : "No Data"}
              </td>
              <td>
                {admin.EndDate ? getDateddmmyyyy(admin.EndDate) : "No Data"}
              </td>
              <td>{admin.BudgetHours || "No Data"}</td>
              <td>
                {/* Correctly check the boolean value of IsInternal */}
                {admin.IsInternal === true ? "Internal" : "External"}
              </td>
              <td
                className={`${admin.Status === "Active"
                  ? "status-green"
                  : admin.Status === "Close"
                    ? "status-green-dark"
                    : admin.Status === "New"
                      ? "status-label-grey"
                      : "status-red"
                  }`}
              >
                {admin.Status || "No Data"}
              </td>
              {/* Action column logic remains commented out as per your code */}
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  return (
    <>
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="role-content">
          <div className="sub-header-role mb-4">
            <h6 className="mt-2">Client Projects</h6>

          </div>
          <div className="d-flex justify-content-between mainHeader custom-mb">
            <div className="role-table-header-main">
              <div className="search-input-wrapper m-0">
                <input
                  type="text"
                  placeholder="Search Project Name"
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    setCurrentPage(0);
                  }}
                />
                {Dark === "lightMode" ? (
                  <img src={searchicon} alt="" />
                ) : (
                  <img src={ic_search_dark} alt="" />
                )}
              </div>
              {/* <div className="entries-wrapper-main">
                <p>Entries per page </p>&nbsp;
                <select
                  className="form-select select-drop-icon"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setUsersPerPage(e.target.value);
                    setCurrentPage(0);
                  }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25" selected>
                    25
                  </option>
                </select>
              </div> */}
              <div className="entries-wrapper-main">
                <p>Filter By Status </p>&nbsp;
                <select
                  className="form-select select-drop-icon"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setFilterBy(e.target.value);
                    setCurrentPage(0);
                  }}
                >
                  <option value="Active">Active</option>
                  <option value="New">New</option>
                  <option value="Close">Close</option>
                  <option value="Holded">Hold</option>
                </select>
              </div>
            </div>
            <div className="d-flex justify-content-between mainIcons">
              {permissions && permissions["Project Bulk Upload"] && (
                <div className="shareIcon mx-3">
                  <img src={shareIcon} className="innerIconsBtn" alt="" />
                </div>
              )}
              {permissions && permissions["Project Export"] && (
                <div className="booksIcon">
                  {excelLoading ? (
                    <ExcelLoader />
                  ) : (
                    <img
                      src={BookIcon}
                      // onClick={(e) => downloadExcelFile(e)}
                      className="innerIconsBtn"
                      alt=""
                    />
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="table-wrapper" id="scrol-tblNtable-wrapper-af">
            {loading ? (
              <div>
                <Loader />
              </div>
            ) : (
              <>
                {projectData && projectData.length > 0 ? (
                  <>
                    {searchValue === ""
                      ? displayAdminTask
                      : displaySearchAdminTask}
                  </>
                ) : (
                  <>
                    <NoData />
                  </>
                )}
              </>
            )}
          </div>
          <Pagination
            data={projectData?.filter((data) => data?.Status == filterBy)}
            pageChangeHandler={pageChangeHandler}
            usersPerPage={usersPerPage}
            currentPage={currentPage}
            searchValue={searchValue}
            searchedDataPageCounts={searchedDataPageCounts}
          />
        </div>
      </div>

      {/* MODALS*/}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header>
          <Modal.Title>
            <label htmlFor="" className="create-role-text">
              Add New Project
            </label>
          </Modal.Title>
          <div className="rightAxe">
            <img
              src={Axe}
              alt=""
              onClick={() => {
                setShow(false);

                setClientErr(initialErr);

                clearForm();
              }}
            />
          </div>
        </Modal.Header>
        <div className="hr-line-modal">
          <hr style={{ margin: "0" }} />
        </div>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <div className="modalProp mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Project Name
                </label>
                <input
                  type="text"
                  name="ProjectName"
                  onChange={(e) => {
                    changeData(e);
                  }}
                  className="form-control tasKCategory1"
                />
                {clientErr.ProjectNameErr && (
                  <label className="validationTxt">
                    {clientErr.ProjectNameErr}
                  </label>
                )}
                {/* {clientErr.ProjectNameErr.length > 0 && (
                  <label className="validationTxt">
                    {clientErr.ProjectNameErr}
                  </label>
                )}
                 {!clientErr.ProjectNameErr && projStateData.ProjectName && (
                  <label className="validationTxt">
                    {""}
                  </label>
                )} */}
              </div>
              <div className="modalProp mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Client Name
                </label>
                <select
                  className="form-select tasKCategory1 select-drop-icon"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setProjStateData({
                      ...projStateData,
                      ClientId: Number(e.target.value),
                    });
                  }}
                  name="ClientId"
                  value={projStateData?.ClientId}
                >
                  <option>Select Client Name</option>
                  {clientOptions.map((name, index) => {
                    return (
                      <option value={name.ClientID}>{name.CustomerName}</option>
                    );
                  })}
                </select>
                {clientErr.ClientIdErr && !projStateData?.ClientId && (
                  <label className="validationTxt">
                    {clientErr.ClientIdErr}
                  </label>
                )}
                {/* <label className="validationTxt">{clientErr.ClientIdErr}</label> */}
              </div>
              <div className="modalProp mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Department
                </label>
                <select
                  className="form-select tasKCategory1 select-drop-icon"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setProjStateData({
                      ...projStateData,
                      DepartmentId: e.target.value,
                    });
                  }}
                  value={projStateData?.DepartmentId}
                  name="DepartmentId"
                >
                  <option>Select Department Name</option>
                  {departmentOptions &&
                    departmentOptions.map((data) => {
                      return (
                        <option value={data.Id}>{data.DepartmentName}</option>
                      );
                    })}
                </select>

                {clientErr.DepartmentIdErr && !projStateData?.DepartmentId && (
                  <label className="validationTxt">
                    {clientErr.DepartmentIdErr}
                  </label>
                )}
              </div>
              <div className="modalProp  mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Project Owner/Admin
                </label>
                <select
                  className="form-select tasKCategory1 select-drop-icon"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setProjStateData({
                      ...projStateData,
                      ProjAdmin: Number(e.target.value),
                    });
                  }}
                  value={projStateData.ProjAdmin}
                  name="ProjAdmin"
                >
                  <option>Select Owner/Admin Name</option>
                  {ownerList &&
                    ownerList.map((data) => {
                      return (
                        <option value={data.Id}>{data.FirstName + " "}</option>
                      );
                    })}
                </select>
                {clientErr.ProjAdminErr && !projStateData.ProjAdmin && (
                  <label className="validationTxt">
                    {clientErr.ProjAdminErr}
                  </label>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Project Type
                </label>
                {/* <div className="d-flex justify-content-between"> */}
                <div class="form-check">
                  <input
                    class="form-check-input"
                    onChange={(e) => {
                      setProjStateData({
                        ...projStateData,
                        IsInternal: true,
                        IsExternal: false,
                      });
                    }}
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                  />
                  <label
                    class="form-check-label cursor"
                    for="flexRadioDefault1"
                  >
                    Internal
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    onChange={(e) => {
                      setProjStateData({
                        ...projStateData,
                        IsInternal: false,
                        IsExternal: true,
                      });
                    }}
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault2"
                  />
                  <label
                    class="form-check-label cursor"
                    for="flexRadioDefault2"
                  >
                    External
                  </label>
                </div>
                <label className="validationTxt">
                  {clientErr.IsInternalErr}
                </label>
                {/* </div> */}
              </div>
              <div className="mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Contract Model
                </label>
                {/* <div className="d-flex justify-content-between"> */}
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault3"
                    id="Time&Material"
                    onChange={(e) => {
                      setProjStateData({
                        ...projStateData,
                        ContractedModel: e.target.checked,
                      });
                    }}
                  />
                  <label class="form-check-label cursor" for="Time&Material">
                    Time & Material
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault3"
                    id="FixedPrice"
                    onChange={(e) => {
                      setProjStateData({
                        ...projStateData,
                        ContractedModel: e.target.checked,
                      });
                    }}
                  />
                  <label class="form-check-label cursor" for="FixedPrice">
                    Fixed Price
                  </label>
                </div>
                {/* </div> */}
              </div>
            </div>
            <div className="col-md-6">
              <div className="modalProp mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Rate
                </label>
                <input
                  type="text"
                  name="Rate"
                  onChange={(e) => {
                    setProjStateData({
                      ...projStateData,
                      Rate: Number(e.target.value),
                    });
                  }}
                  value={projStateData.Rate}
                  className="form-control tasKCategory1"
                />
                {clientErr.RateErr && !projStateData.Rate && (
                  <label className="validationTxt">{clientErr.RateErr}</label>
                )}
              </div>
              <div className="modalProp mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Project Awarded Date
                </label>
                <input
                  type="date"
                  name="ProjectAwardedDate"
                  onChange={(e) => {
                    changeData(e);
                  }}
                  value={projStateData.ProjectAwardedDate?.split(
                    "T"
                  )[0].replaceAll("/", "-")}
                  className="date-label-input tasKCategory1"
                  style={{
                    fontSize: "14px",
                    height: "38px",
                    border: "1px solid #ced4da",
                  }}
                />
                {clientErr.ProjectAwardedDateErr && (
                  <label className="validationTxt">
                    {clientErr.ProjectAwardedDateErr}
                  </label>
                )}
              </div>
              <div className="modalProp mb-4">
                <label
                  htmlFor=""
                  className="enter-role-text mt-2"
                  style={{ fontSize: "14px" }}
                >
                  Project Start Date
                </label>
                <input
                  onChange={(e) => {
                    changeData(e);
                  }}
                  name="StartDate"
                  value={projStateData.StartDate?.split("T")[0].replaceAll(
                    "/",
                    "-"
                  )}
                  type="date"
                  className="date-label-input tasKCategory1"
                  style={{
                    fontSize: "14px",
                    height: "38px",
                    border: "1px solid #ced4da",
                  }}
                />
                {clientErr.StartDateErr && (
                  <label className="validationTxt">
                    {clientErr.StartDateErr}
                  </label>
                )}
              </div>
              <div className="modalProp  mb-4">
                <label
                  htmlFor=""
                  className="enter-role-text mt-2"
                  style={{ fontSize: "14px" }}
                >
                  Project End Date
                </label>
                <input
                  disabled={!projStateData.StartDate}
                  onChange={(e) => {
                    changeData(e);
                  }}
                  name="EndDate"
                  value={projStateData.EndDate?.split("T")[0].replaceAll(
                    "/",
                    "-"
                  )}
                  min={projStateData?.StartDate}
                  type="date"
                  className="date-label-input tasKCategory1"
                  style={{
                    fontSize: "14px",
                    height: "38px",
                    border: "1px solid #ced4da",
                  }}
                />
                {clientErr.EndDateErr && (
                  <label className="validationTxt">
                    {clientErr.EndDateErr}
                  </label>
                )}
              </div>
              <div className="modalProp mb-4">
                <label
                  htmlFor=""
                  className="enter-role-text mt-2"
                  style={{ fontSize: "14px" }}
                >
                  Estimate Hours
                </label>
                <input
                  onChange={(e) => {
                    changeData(e);
                  }}
                  name="EstimatedTime"
                  value={projStateData.EstimatedTime}
                  type="number"
                  placeholder="0"
                  className="date-label-input tasKCategory1"
                  style={{
                    fontSize: "14px",
                    height: "38px",
                    border: "1px solid #ced4da",
                  }}
                />
                {clientErr.EstimatedTimeErr && !projStateData.EstimatedTime && (
                  <label className="validationTxt">
                    {clientErr.EstimatedTimeErr}
                  </label>
                )}
              </div>
              <div className="modalProp mb-4">
                <label
                  htmlFor=""
                  className="enter-role-text mt-2"
                  style={{ fontSize: "14px" }}
                >
                  Description
                </label>
                <textarea
                  class="form-control tasKCategory1"
                  rows={3}
                  placeholder="Leave a comment here"
                  id="floatingTextarea"
                  onChange={(e) => {
                    changeData(e);
                    setClientErr({
                      ...clientErr,
                      DescriptionErr: "",
                    });
                  }}
                  name="Description"
                  value={projStateData.Description}
                ></textarea>
                {clientErr.DescriptionErr && (
                  <label className="validationTxt">
                    {clientErr.DescriptionErr}
                  </label>
                )}
              </div>
              {/* <div className="modalProp mb-4 ">

                {
                  gitUrls.map((url, index) => {
                    return <div >
                      <label
                        htmlFor=""
                        className="enter-role-text mt-2"
                        style={{ fontSize: "14px" }}
                      >
                        Git Url {index + 1}
                      </label>
                      <input
                        onChange={(e) => {

                          let temp = [...gitUrls]

                          temp[index] = {
                            ...temp[index],
                            URL: e.target.value
                          }

                          setGitUrls(temp)
                        }}
                        name="giturl"
                        value={url.URL}
                        type="text"
                        className="date-label-input tasKCategory1"
                        style={{
                          fontSize: "14px",
                          height: "38px",
                          border: "1px solid #ced4da",
                        }}
                      />
                      <label className="validationTxt">

                        {urlValidation && !urlTest(url.URL) && 'Please Enter Valid Url'}
                      </label>
                    </div>
                  })
                }
                <div >
                  <button className="modal-cancel-btn branchList-modal-cancel-btn-arbaz-responsive"
                    onClick={addGitUrl}
                  >+</button>
                </div>
              </div> */}
            </div>
          </div>
        </Modal.Body>

        <div className="hr-line-modal-1">
          <hr style={{ margin: "0" }} />
        </div>
        <Modal.Footer className="model-footer-arbaz-responsive">
          {/* <div className='Bottom-btn-arbaz-responsive'> */}
          <button
            type="button"
            className="modal-cancel-btn branchList-modal-cancel-btn-arbaz-responsive"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            className="modal-create-btn branchList-modal-cancel-btn-arbaz-responsive"
            // onClick={addProject}
            disabled={projectUpdateLoading}
          >
            {projectUpdateLoading ? (
              <div
                class="spinner-border text-light"
                role="status"
                style={{
                  marginTop: "5px",
                  width: "1.3rem",
                  height: "1.3rem",
                  marginLeft: "40%",
                }}
              ></div>
            ) : (
              "Add"
            )}
          </button>
          {/* </div> */}
        </Modal.Footer>
      </Modal>

      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={edit}
        onHide={() => {
          setEdit(false);
          setClientErr(initialErr);
          setProjStateData({
            ProjectName: "",
            Description: "",
            ProjAdmin: 0,
            StartDate: "",
            EndDate: "",
            IsInternal: false,
            EstimatedTime: "",
            Status: 0,
            DepartmentId: "",
            ProjectAwardedDate: "",
            ContractedModel: false,
            Rate: 0,
            ClientId: 0,
          });
        }}
      >
        <Modal.Header>
          <Modal.Title>
            <label htmlFor="" className="create-role-text">
              Edit Project
            </label>
          </Modal.Title>
          <div className="rightAxe">
            <img
              src={Axe}
              alt=""
              onClick={() => {
                setEdit(false);
                setClientErr(initialErr);
                clearForm();
                setGitUrls([
                  {
                    RepositoryId: 0,
                    ProjectId: 0,
                    URL: "",
                  },
                ]);

                setUrlValidation(false);
              }}
            />
          </div>
          {/* <img src={close} alt="" onClick={handleClose} className="cr-class" /> */}
        </Modal.Header>
        <div className="hr-line-modal">
          <hr style={{ margin: "0" }} />
        </div>

        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <div className="modalProp mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Project Name
                </label>
                <input
                  type="text"
                  value={projStateData?.ProjectName}
                  name="ProjectName"
                  onChange={(e) => {
                    changeData(e);
                    setClientErr({
                      ...clientErr,
                      ProjectNameErr: "",
                    });
                  }}
                  className="form-control tasKCategory1"
                />
                {clientErr.ProjectNameErr && (
                  <label className="validationTxt">
                    {clientErr.ProjectNameErr}
                  </label>
                )}
              </div>
              <div className="modalProp mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Client Name
                </label>
                <select
                  className="form-select tasKCategory1 select-drop-icon"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setProjStateData({
                      ...projStateData,
                      ClientId: Number(e.target.value),
                    });
                    setClientErr({
                      ...clientErr,
                      CustomerName: "",
                    });
                  }}
                  value={projStateData?.ClientId}
                >
                  <option>Select Client Name</option>
                  {clientOptions.map((name, index) => {
                    return (
                      <option value={name?.ClientID}>
                        {name.CustomerName}
                      </option>
                    );
                  })}
                </select>

                <label className="validationTxt">{clientErr.ClientIdErr}</label>
              </div>
              <div className="modalProp mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Department
                </label>
                <select
                  className="form-select tasKCategory1 select-drop-icon"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setProjStateData({
                      ...projStateData,
                      DepartmentId: e.target.value,
                    });
                    setClientErr({
                      ...clientErr,
                      DepartmentName: "",
                    });
                  }}
                  value={projStateData?.DepartmentId}
                >
                  <option>Select Department Name</option>
                  {departmentOptions &&
                    departmentOptions.map((data) => {
                      return (
                        <option value={data.Id}>{data.DepartmentName}</option>
                      );
                    })}
                </select>

                <label className="validationTxt">
                  {clientErr.DepartmentIdErr}
                </label>
              </div>
              <div className="modalProp  mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Project Owner/Admin
                </label>
                <select
                  className="form-select tasKCategory1 select-drop-icon"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setProjStateData({
                      ...projStateData,
                      ProjAdmin: Number(e.target.value),
                    });
                    setClientErr({
                      ...clientErr,
                      ProjAdminErr: "",
                    });
                  }}
                  value={projStateData.ProjAdmin}
                >
                  <option>Select Owner/Admin Name</option>
                  {ownerList &&
                    ownerList.map((data) => {
                      return (
                        <option value={data.Id}>{data.FirstName + " "}</option>
                      );
                    })}
                </select>

                <label className="validationTxt">
                  {clientErr.ProjAdminErr}
                </label>
              </div>
              <div className="mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Project Type
                </label>

                {/* Internal */}
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    checked={projStateData.IsInternal === true}
                    onChange={(e) => {
                      setProjStateData({
                        ...projStateData,
                        IsInternal: true,
                        IsExternal: false,
                      });
                    }}
                  />
                  <label
                    className="form-check-label cursor"
                    htmlFor="flexRadioDefault1"
                  >
                    Internal
                  </label>
                </div>

                {/* External */}
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault2"
                    checked={projStateData.IsExternal === true}
                    onChange={(e) => {
                      setProjStateData({
                        ...projStateData,
                        IsInternal: false,
                        IsExternal: true,
                      });
                    }}
                  />
                  <label
                    className="form-check-label cursor"
                    htmlFor="flexRadioDefault2"
                  >
                    External
                  </label>
                </div>

                <label className="validationTxt">
                  {clientErr.IsInternalErr}
                </label>
              </div>

              <div className="mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Contract Model
                </label>
                {/* <div className="d-flex justify-content-between"> */}
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault3"
                    id="Time&Material"
                  />
                  <label
                    class="form-check-label cursor"
                    for="Time&Material"
                    onChange={(e) => {
                      setProjStateData({
                        ...projStateData,
                        ContractedModel: e.target.checked,
                      });
                    }}
                    checked={projStateData.ContractedModel}
                  >
                    Time & Material
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault3"
                    id="FixedPrice"
                    onChange={(e) => {
                      setProjStateData({
                        ...projStateData,
                        ContractedModel: e.target.checked,
                      });
                    }}
                    checked={projStateData?.ContractedModel}
                  />
                  <label class="form-check-label cursor" for="FixedPrice">
                    Fixed Price
                  </label>
                </div>
                {/* </div> */}
              </div>
            </div>
            <div className="col-md-6">
              <div className="modalProp mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Rate
                </label>
                <input
                  type="text"
                  name="Rate"
                  onChange={(e) => {
                    setProjStateData({
                      ...projStateData,
                      Rate: Number(e.target.value),
                    });
                    setClientErr({
                      ...clientErr,
                      RateErr: "",
                    });
                  }}
                  value={projStateData?.Rate}
                  className="form-control tasKCategory1"
                />
                {clientErr.RateErr && (
                  <label className="validationTxt">{clientErr.RateErr}</label>
                )}
              </div>
              <div className="modalProp mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Project Awarded Date
                </label>
                <input
                  type="date"
                  name="ProjectAwardedDate"
                  onChange={(e) => {
                    changeData(e);
                    setClientErr({
                      ...clientErr,
                      ProjectAwardedDateErr: "",
                    });
                  }}
                  value={projectAwardedDate}
                  className="form-control tasKCategory1"
                />
                {clientErr.ProjectAwardedDateErr && (
                  <label className="validationTxt">
                    {clientErr.ProjectAwardedDateErr}
                  </label>
                )}
              </div>
              <div className="modalProp mb-4">
                <label
                  htmlFor=""
                  className="enter-role-text mt-2"
                  style={{ fontSize: "14px" }}
                >
                  Project Start Date
                </label>
                <input
                  onChange={(e) => {
                    changeData(e);
                  }}
                  name="StartDate"
                  value={StartDate}
                  type="date"
                  className="date-label-input tasKCategory1"
                  style={{
                    fontSize: "14px",
                    height: "38px",
                    border: "1px solid #ced4da",
                  }}
                />
                <label className="validationTxt">
                  {clientErr.StartDateErr}
                </label>
              </div>
              <div className="modalProp  mb-4">
                <label
                  htmlFor=""
                  className="enter-role-text mt-2"
                  style={{ fontSize: "14px" }}
                >
                  Project End Date
                </label>
                <input
                  onChange={(e) => {
                    changeData(e);
                  }}
                  name="EndDate"
                  value={EndDate}
                  type="date"
                  className="date-label-input tasKCategory1"
                  style={{
                    fontSize: "14px",
                    height: "38px",
                    border: "1px solid #ced4da",
                  }}
                />
                <label className="validationTxt">
                  {projStateData?.EndDate <= projStateData?.StartDate
                    ? clientErr.EndDateErr
                    : ""}
                </label>
              </div>
              <div className="modalProp mb-4">
                <label
                  htmlFor=""
                  className="enter-role-text mt-2"
                  style={{ fontSize: "14px" }}
                >
                  Estimate Hours
                </label>
                <input
                  onChange={(e) => {
                    changeData(e);
                  }}
                  name="EstimatedTime"
                  value={projStateData?.EstimatedTime}
                  type="number"
                  className="date-label-input tasKCategory1"
                  style={{
                    fontSize: "14px",
                    height: "38px",
                    border: "1px solid #ced4da",
                  }}
                />
                <label className="validationTxt">
                  {clientErr.EstimatedTimeErr}
                </label>
              </div>
              <div className="modalProp mb-3">
                <label htmlFor="" className="enter-role-text my-2">
                  Status
                </label>
                <select
                  className="form-select tasKCategory1 select-drop-icon"
                  aria-label="Default select example"
                  value={projStateData?.Status}
                  name="Status"
                  onChange={(e) => {
                    setProjStateData({
                      ...projStateData,
                      Status: parseInt(e.target.value),
                    });
                    // setClientErr({
                    //   ...clientErr,
                    //   DepartmentName: ''
                    // })
                  }}
                >
                  <option value="">Select Status</option>
                  <option value="1">New</option>
                  <option value="2">Active</option>
                  <option value="3">Closed</option>
                  <option value="4">Holded</option>
                  {/* {departmentOptions &&
                    departmentOptions.map(data => {
                      return (
                        <option value={data.Id}>{data.DepartmentName}</option>
                      )
                    })} */}
                </select>
                {/* {clientErr.DepartmentName && (
                  <label className='validationTxt'>
                    {clientErr.DepartmentName}
                  </label>
                )} */}
              </div>
              <div className="modalProp mb-4">
                <label
                  htmlFor=""
                  className="enter-role-text mt-2"
                  style={{ fontSize: "14px" }}
                >
                  Descriptions
                </label>
                <textarea
                  class="form-control tasKCategory1"
                  rows={3}
                  placeholder="Leave a comment here"
                  id="floatingTextarea"
                  onChange={(e) => {
                    changeData(e);
                  }}
                  name="Description"
                  value={projStateData?.Description}
                ></textarea>
              </div>

              {/* <div className="modalProp mb-4 ">
                {
                  gitUrls.map((url, index) => {
                    return <div >
                      <label
                        htmlFor=""
                        className="enter-role-text mt-2"
                        style={{ fontSize: "14px" }}
                      >
                        Git Url {index + 1}
                      </label>
                      <input
                        onChange={(e) => {

                          let temp = [...gitUrls]

                          temp[index] = {
                            ...temp[index],
                            URL: e.target.value
                          }

                          setGitUrls(temp)
                        }}
                        name="giturl"
                        value={url.URL}
                        type="text"
                        className="date-label-input tasKCategory1"
                        style={{
                          fontSize: "14px",
                          height: "38px",
                          border: "1px solid #ced4da",
                        }}
                      />
                      <label className="validationTxt">
                        {urlValidation && !urlTest(url.URL) && 'Please Enter Valid Url'}
                      </label>
                    </div>
                  })
                }
                <div >
                  <button className="modal-cancel-btn branchList-modal-cancel-btn-arbaz-responsive"
                    onClick={addGitUrl}
                  >+</button>
                </div>
              </div> */}
            </div>
          </div>
        </Modal.Body>

        <div className="hr-line-modal-1">
          <hr style={{ margin: "0" }} />
        </div>
        <Modal.Footer className="model-footer-arbaz-responsive">
          <button
            className="modal-cancel-btn branchList-modal-cancel-btn-arbaz-responsive"
            onClick={() => {
              setClientErr(initialErr);
              setEdit(false);
              clearForm();
            }}
          >
            Cancel
          </button>
          <button
            className="modal-create-btn branchList-modal-cancel-btn-arbaz-responsive"
            onClick={updateProject}
            disabled={projectUpdateLoading}
          >
            {projectUpdateLoading ? (
              <div
                class="spinner-border text-light"
                role="status"
                style={{
                  marginTop: "5px",
                  width: "1.3rem",
                  height: "1.3rem",
                  marginLeft: "40%",
                }}
              ></div>
            ) : (
              "Update"
            )}
          </button>
        </Modal.Footer>
      </Modal>
      {/* Delete News and Blogs Modal Start */}
      <Modal
        className="delete-news-modal"
        show={show3}
        onHide={handleClose3}
        dialogClassName="modal-90w"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="delete-title">
            Delete Confirmation
          </Modal.Title>
        </Modal.Header>
        <div class="lineSeperate"></div>
        <Modal.Body className="delete-body ps-4">
          <p>
            Are you sure you want to delete this Project{" "}
            {"( " + deleteProjectName + " )"} ?
          </p>
        </Modal.Body>

        <div className="lineSeperate"></div>
        <div className="d-flex justify-content-end align-items-center mainBtnsSub">
          <button className="btn-width cancelBtn mx-3" onClick={handleClose3}>
            Cancel
          </button>
          <button
            className="btn-width saveBtn"
            onClick={() => {
              deleteProject(useDeleteTaskList);
              handleClose3();
            }}
          >
            Delete
          </button>
        </div>
      </Modal>
      {/* Delete News and Blogs Modal End */}
    </>
  );
};

export default ViewList;
